import React from "react";
import heroImg from "../assets/hero.jpeg.avif";

const Hero = () => {
  return (
    <>
      <style>{`
        .hero {
          position: relative;
          height: 100vh;
          display: flex;
          align-items: center;
          color: white;
          overflow: hidden;
        }

        /* BACKGROUND IMAGE */
        .hero::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url(${heroImg}) center/cover no-repeat;
          z-index: 1;
        }

        /* GREEN OVERLAY */
        .hero::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          
          background: linear-gradient(
            90deg,
            rgba(15, 61, 46, 0.9) 0%,
            rgba(15, 61, 46, 0.7) 40%,
            rgba(15, 61, 46, 0.3) 70%,
            rgba(15, 61, 46, 0.1) 100%
          );

          z-index: 2;
        }

        /* CONTENT */
        .hero-content {
          position: relative;
          z-index: 3;
          max-width: 600px;
          margin-left: 80px;
        }

        .hero h1 {
          font-size: 48px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 20px;
        }

        .hero p {
          font-size: 16px;
          color: #dcdcdc;
          margin-bottom: 25px;
        }

        .hero-btn {
          background: #7ED957;
          color: black;
          padding: 12px 22px;
          border: none;
          border-radius: 999px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
          text-decoration: none;
        }

        .hero-btn:hover {
          background: #D4AF37;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .hero-content {
            margin-left: 20px;
            margin-right: 20px;
          }

          .hero h1 {
            font-size: 32px;
          }
        }
      `}</style>

      <section className="hero">
        <div className="hero-content">
          <h1>
            Expert CPAs and Tax <br />
            Advisors to Save More, <br />
            Stress Less
          </h1>

          <p>
            From bookkeeping to tax planning, we help you manage your
            finances with clarity, confidence, and care.
          </p>

          <a href="tel:+919151622122" className="hero-btn">
  Book Discovery Call ↗
</a>
        </div>
      </section>
    </>
  );
};

export default Hero;